import { TranslateService } from '@ngx-translate/core';

import { signal } from '@angular/core';
import { inject, Injectable } from '@angular/core';
import { ErrorMessage } from '../model/error-message';

@Injectable({ providedIn: 'root' })
export class ErrorService {
  private readonly translateService = inject(TranslateService);

  onError = signal<ErrorMessage | null>(null);
  onLoginError = signal<any>(null);

  constructor() {}
  responseError(response: any) {
    if (response) {
      if (response.status === 500) {
        this.emitError(response.status, response.statusText, '');
      } else if (
        response.status === 501 ||
        response.status === 502 ||
        response.status === 503 ||
        response.status === 504
      ) {
        this.emitError(response.status, response.statusText, '');
      } else if (response.status === 401) {
        this.emitLoginError(response);
      } else if (response.status !== 200) {
        this.emitError(response.status, response.statusText, response.body.message);
      } else if (response.body?.success != null && response.body.success === false) {
        // Weil HTTP 200 und dennoch fachlicher Fehler den Status auf 500 setzen
        //TODO: sowas grundsätzlich in der Anwendung bearbeiten und nicht als generische Fehlermeldung ausgeben
      } else {
        this.translateService.get('technischerFehler.errorTypes.unkown').subscribe((error) => {
          this.onError.set(error);
        });
      }
    } else {
      this.translateService.get('technischerFehler.errorTypes.unkown').subscribe((error) => {
        this.onError.set(error);
      });
    }
  }

  emitLoginError(response: any) {
    //bei Auth Fehlern den Localstorage löschen
    //Fehler wird auf der Loginseite angezeigt
    this.onLoginError.set(response.error);
  }

  emitError(status: number, statusText: string, text: string) {
    //allgmeiner Fehlerdialog wird angezeigt,
    // Fehlertext kann dann in die Zwischenablage kopiert werden
    const error: ErrorMessage = new ErrorMessage(status, statusText, text);
    this.onError.set(error);
  }
}
